import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectAccounts } from 'stash/selectors';
import { setInvestAddonValueProp } from 'stash/actions';
import {
	Box,
	Text,
	PrimaryButton,
	SmartLink,
	Layout,
	VideoContainer,
	BarGraphIllustration,
} from '@stashinvest/ui';
import { useEntitlements, OPEN_ACCOUNT_PERSONAL_SELF } from 'stash/hooks/useEntitlements';

const mapStateToProps = (state) => ({
	accounts: selectAccounts(state),
	account_by_type: state.entities.account_by_type,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	onConfirm: () => {
		dispatch(setInvestAddonValueProp(true));
		return ownProps.completeStep();
	},
});

const SignUpInvestValueProp = ({ accounts, account_by_type, onConfirm }) => {
	const { isEntitlementsLoading, hasEntitlement } = useEntitlements();
	const investAccount = accounts[account_by_type.PERSONAL_BROKERAGE];
	const isEligible = !isEntitlementsLoading && hasEntitlement(OPEN_ACCOUNT_PERSONAL_SELF);

	return (
		<Layout.PageWrap pt="3rem" mb="xl">
			<Box width="90%" maxWidth="28rem" mx="auto">
				<BarGraphIllustration mx="auto" />
				<Text.H1 mb="xs" align="center">
					Always. Be. Investing.
				</Text.H1>
				<Text mb="l" align="center">
					Looking to conquer some goals before retirement? <br />
					Try a personal investment account.
				</Text>
				<VideoContainer mb="l">
					<iframe
						src="https://www.youtube.com/embed/GxPLfGODsDY"
						title="YouTube video player"
						id="youtubeIframe"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						width="100%"
						allowFullScreen
					/>
				</VideoContainer>
				{isEligible && !investAccount ? (
					<PrimaryButton as={SmartLink} onClick={onConfirm}>
						Open personal investment account
					</PrimaryButton>
				) : !isEligible && !investAccount ? (
					<PrimaryButton as={SmartLink} to="/manage-subscription">
						Upgrade to open account
					</PrimaryButton>
				) : null}
			</Box>
		</Layout.PageWrap>
	);
};

SignUpInvestValueProp.propTypes = {
	accounts: PropTypes.object,
	account_by_type: PropTypes.object,
	onConfirm: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpInvestValueProp);
